import React, { useEffect, useState } from 'react'
import {Link} from "react-router-dom";
import {connect} from "react-redux";
import {adminHttp} from "~/Admin/services/http";
import Pagination from "react-js-pagination";
import AdminAddTranslation from "./AdminAddTranslation";
import deleteIcon from "~/assets/icons/delete.png";
import ConfirmedLink from "~/Components/ConfirmedButton/ConfirmedLink";
import {ChevronRight, EditIcon} from "~/Components/Icons/Icons";
import AdminEditTranslation from "./AdminEditTranslation";
import {DebounceInput} from "react-debounce-input";
import classnames from 'classnames';

const AdminTranslations = ({match, event, translationSections = [], ...props}) => {

    const [response, setResponse] = useState({});

    const [activeSectionId, setActiveSectionId] = useState('');

    const [filter, setFilter] = useState({
        search: '',
    });

    const handleFilter = (e) => {
        const name = e.target.name;
        const value = e.target.value;

        let filterData = {...filter, [name]: value};

        setFilter(filterData);
    };

    const loadData = (page = 1) => {
        adminHttp
            .get(`/translations?${new URLSearchParams(filter).toString()}&page=${page}&sectionId=${activeSectionId}`)
            .then(res => setResponse(res.data));
    };

    const handleDelete = (id) => {
        adminHttp
            .delete('/translations/' + id)
            .then(res => loadData());
    };

    useEffect(loadData, [filter, event, activeSectionId]);

    return (
        <div className="languages">
            <div className="row">
                <div className="col-8">
                    <h2>Translations</h2>
                </div>
                <div className="col-4 text-right">
                    <AdminAddTranslation
                        sections={translationSections}
                        onChange={loadData}
                        className="btn btn-primary btn-sm">Add Translation</AdminAddTranslation>
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    <div className="card shadow-sm bg-white reports-filter">
                        <div className="row pt-2 pb-2">
                            <div className="col-2">
                                <label className="mt-2 ml-4 text-muted">SEARCH</label>
                            </div>
                            <div className="col-10">

                                <div className="row">
                                    <div className="col-6">
                                        <DebounceInput
                                            onChange={handleFilter}
                                            value={filter.search}
                                            name="search"
                                            className="form-control mr-4 "/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="mt-4">
                <div className="col-12 row m-0 p-0">
                    <div className="list-group col-3">
                        <a
                            className={classnames('list-group-item list-group-item-action cursor-pointer', {active: activeSectionId === ''})}
                            onClick={() => setActiveSectionId('')}
                        >
                            All
                        </a>
                        {translationSections.map(section =>
                            <a key={section.name} onClick={() => setActiveSectionId(section.id)}
                            className={classnames('list-group-item list-group-item-action cursor-pointer', {active: activeSectionId === section.id})}>
                                {section.name}
                            </a>
                        )}
                    </div>

                    <div className="card shadow-sm bg-white col-9 p-0">
                        <div className="card-body">
                            <table className="table">

                                <thead>
                                <tr>
                                    <th scope="col">#</th>
                                    <th scope="col">Name</th>
                                    <th scope="col">Section</th>
                                    <th scope="col">Category</th>
                                    <th scope="col"></th>
                                </tr>
                                </thead>

                                <tbody>
                                {response.data?.map((trans) => (
                                    <tr key={trans.id}>
                                        <td>{trans.id}</td>
                                        <td>{trans.name}</td>
                                        <td>{trans.translation_section || '-'}</td>
                                        <td>{trans.category}</td>
                                        <td>
                                            <Link className="cursor-pointer float-right" to={`${match.path}view/${trans.id}`}>
                                                <ChevronRight/>
                                            </Link>

                                            <ConfirmedLink className="cursor-pointer float-right mr-2" onClick={() => handleDelete(trans.id)}>
                                                <img src={deleteIcon}/>
                                            </ConfirmedLink>

                                            <AdminEditTranslation translation={trans} onChange={loadData} sections={translationSections} className="cursor-pointer float-right mr-2">
                                                <EditIcon />
                                            </AdminEditTranslation>
                                        </td>
                                    </tr>
                                ))}
                                </tbody>

                            </table>
                            {
                                // No translations found
                                response?.data?.length ? null : <p className="text-center">No translations found.</p>
                            }

                            {response.per_page < response.total && (
                                <Pagination
                                    activePage={response.current_page}
                                    itemsCountPerPage={response.per_page}
                                    totalItemsCount={response.total}
                                    pageRangeDisplayed={5}
                                    itemClass="page-item"
                                    linkClass="page-link"
                                    onChange={loadData}
                                />
                            )}
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => ({
    user: state.auth?.user,
    event: state.event.current,
    translationSections: state.language?.translationSections
});

export default connect(mapStateToProps)(AdminTranslations);
